<template>
    <div class="text-left pa-4">{{ noDataMessage || $t('no_results_found') }}</div>
</template>

<script>
export default {
    name: 'NoData',
    props: {
        noDataMessage: {
            type: String,
            default: null
        }
    }
};
</script>
